export type AssessmentOutcomeKey =
  | 'egfr'
  | 'bestResultFlag'
  | 'algorithmResult'
  | `consequence:${number}`
  | 'spirometryReversibility'
  | 'identifier'
  | 'isAggregatedFormula'
  | 'unknown';

const allowedStaticOutcomeKeys: AssessmentOutcomeKey[] = [
  'egfr',
  'bestResultFlag',
  'algorithmResult',
  'spirometryReversibility',
  'identifier',
  'isAggregatedFormula',
];

const isAssessmentOutcomeKey = (value: string): value is AssessmentOutcomeKey =>
  (allowedStaticOutcomeKeys as string[]).includes(value) || keyIsConsequence(value);

const from = (value: string): AssessmentOutcomeKey => {
  if (!isAssessmentOutcomeKey(value)) {
    return AssessmentOutcomeKey.unknown;
  }

  return value;
};

const keyIsConsequence = (value: string): value is AssessmentOutcomeKey => /consequence:(\d+)/.test(value);

export const AssessmentOutcomeKey = {
  ACR: 'ACR',
  egfr: 'egfr',
  bestResultFlag: 'bestResultFlag',
  algorithmResult: 'algorithmResult',
  consequence: 'consequence',
  spirometryReversibility: 'spirometryReversibility',
  identifier: 'identifier',
  isAggregatedFormula: 'isAggregatedFormula',
  unknown: 'unknown',
  from,
  keyIsConsequence,
} as const;
